import React from "react"
import { useModal } from "../../../../stores/useModal"
import clx from "classnames";
import { FiLayout, FiMenu, FiPhone,  FiSearch, FiUser } from 'react-icons/fi'
import Option from './option'
import { useDrawer } from "../../../../stores/useDrawer";
import { Darkmode } from "../../../shared/darkmode";

export const Header = ({
    search,
    setSearch,
    phone,
    setPhone,
    detail,
    setDetail,
    profile,
    setProfile
}) => {
  const modal = useModal(state=>state)    
  const drawer = useDrawer(state=>state)    
  const openPhoneCall = () => modal.open({type:'phone-call', values:{}})
  const openMenu = () => drawer.open({type:'support-menu'})

    return (
        <React.Fragment>
            <div
              class="header relative bg-gray-200/30 backdrop-blur-md dark:bg-[#141618]/30 sticky top-0 z-30 p-3 px-5 w-full flex-col md:flex-row flex justify-between items-center"
            >
              <div class="flex gap-3 items-center">
                <img
                  src="/images/brands/gitlab.png"
                  class="h-12 w-12 rounded-full"
                />
                <div>
                  <div class="font-semibold cursor-pointer">Artifical Intelligence Productive Team</div>
                  <p class="text-sm text-gray-400">27 members</p>
                </div>
              </div>
              <div class="flex gap-3 items-center">
                <div
                   onClick={()=>setSearch(!search)}
                  className={clx(search?'text-blue-400':'text-gray-400', 'cursor-pointer')}
                >
                  <FiSearch size={23} />
                </div>
                <div
                  onClick={()=>setProfile(!profile)}
                  className={clx(false?'text-blue-400':'text-gray-400','cursor-pointer')}
                >
                  <FiUser size={23} />
                </div>
                <div
                   onClick={()=>{
                    openPhoneCall()
                    setPhone(!phone)
                    }}
                   className={clx(phone?'text-blue-400':'text-gray-400')}
  
                >
                  <FiPhone size={23} class="cursor-pointer" /> 
                </div>
                <div
                   onClick={()=>{
                  //  setDetail(!detail)
                  setDetail(!detail)
                  }}
                   className={clx(detail?'text-blue-400':'text-gray-400')}
                >
                  <FiLayout size={23} class="cursor-pointer" /> 
                </div>
  
               <Option />
  
              <Darkmode />
  
                <div
                  onClick={openMenu}
                  class="md:hidden"
                  // :class="menu?'text-blue-400':'text-gray-400'"
                >
                  <FiMenu class="cursor-pointer" />
                </div>
              </div>
  
              {/** SEARCH COMPONENT **/}
             {search && (
                <div
                class="absolute dark:bg-zinc-800 bg-white p-1 w-full left-0 top-32 sm:top-16 bottom-0 dark:border-zinc-700 border h-12 flex items-center gap-3 px-10"
              >
                <FiSearch class="text-gray-400 h-5"/>
                <input
                  type="text"
                  placeholder="Search..."
                  class="border-none outline-none bg-transparent w-full h-full"
                />
              </div>
             )}
            </div>
        </React.Fragment>
    )
}